<template>
  <div id="app">
    <transition name="fade">
      <router-view/>
    </transition>
    <main-sidebar v-model="isClosed"/>
    <add-to-home-screen-ios-banner v-if="showAddToHomeScreenBanner"/>
  </div>
</template>

<script>
import Vue from 'vue';
import Hammer from 'hammerjs';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLayerGroup, faPlusSquare, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import MainSidebar from './sidebar/MainSidebar.vue';
import AddToHomeScreenIosBanner from './add-to-home/AddToHomeScreenIosBanner.vue';

library.add(faLayerGroup);
library.add(faPlusSquare);
library.add(faTimes);

Vue.component('font-awesome-icon', FontAwesomeIcon);

export default {
  name: 'app',
  components: {
    MainSidebar,
    AddToHomeScreenIosBanner,
  },
  data() {
    return {
      isClosed: true,
      showAddToHomeScreenBanner: false,
    };
  },
  mounted() {
    const app = document.querySelector('#app');
    const manager = new Hammer.Manager(app, {
      touchAction: 'pan-y',
    });
    const swipe = new Hammer.Swipe();
    manager.add(swipe);
    manager.on('swiperight', () => {
      this.isClosed = false;
    });
    manager.on('swipeleft', () => {
      this.isClosed = true;
    });

    // Detects if device is on iOS
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };
    // Detects if device is in standalone mode
    const isInStandaloneMode = () => 'standalone' in window.navigator && window.navigator.standalone;

    // Checks if should display install popup notification:
    if (isIos() && !isInStandaloneMode()) {
      this.showAddToHomeScreenBanner = true;
    }
  },
};
</script>

<style>
html {
  background-color: rgba(0, 0, 0, 0.8);
}

body {
  box-sizing: border-box;
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  height: 100vh;
}

.app-logo {
  height: 200px;
  width: 200px;
}

.fade-enter-active,
.fade-leave-active {
  transition: 0.3s;
}

.fade-enter {
  transform: translate(100%, 0);
}

.fade-leave-to {
  transform: translate(-100%, 0);
}

router-view {
  position: absolute;
  margin: auto 0;
  width: 100%;
  top: 0;
  left: 0;
  bottom: 0;
}
</style>
